import React, { useMemo } from "react";
import styled from "styled-components";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { AnalysisItem } from "../../forms/custom-cdr/threatAnalysis";
import { getChunkedData } from "../../../utils/utilities";
import { Column } from "../../../utils/models";

interface Props {
    items: AnalysisItem[];
}

const Caption = styled.div`
    font-size: 0.875rem;
    color: #000000;
    margin-top: 0.5rem;
    text-align: left;
`;

const CaptionLabel = styled.span`
    color: #4472c4;
    font-weight: 700;
`;

const CDRNumber = styled.div`
    background-color: #ededed;
    border: 2px solid #000000;
    padding: 0.75rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.875rem;
`

const Image = styled.img`
    width: 20rem !important;
    height: 23.8rem !important;
    border: 3px dashed $black !important;
    border-radius: 0.5rem;
    object-fit: fill !important;
`;

const CDRThreatAnalysisPDF: React.FC<Props> = ({ items }) => {
    const itemsWithID = useMemo(() => {
        return items.map((item, index) => ({
            ...item,
            id: index + 1,
            anomalyIndex: index + 1,
        }));
    }, [items]);

    return ( 
       <>
            {getChunkedData(itemsWithID, 2).map((chunk, index) => (
                <CustomSection
                    key={index}
                    showMetadata={false}
                    sectionTitle="Threat Analysis and Evaluation"
                    sectionSubtitle="Threat Analysis and Evaluation"
                    titleStyle={{ paddingLeft: '1rem', justifyContent: 'flex-start', backgroundColor: '#2e4e6a', color: '#FFFFFF', textAlign: 'left' }}
                    subtitleStyle={{ paddingLeft: '1rem', justifyContent: 'flex-start', backgroundColor: '#0076b1', color: '#FFFFFF', textAlign: 'left', textTransform: 'capitalize' }}
                >
                    {chunk.map((item, index) => (
                        <div className="p-1" key={index}>
                            <div className="mb-1">
                                <CDRNumber>
                                    CDR NUMBER: {item.cdrNumber}
                                </CDRNumber>
                            </div>

                            <PDFTablePage data={[item]} columns={imageColumns} />
                        </div>
                    ))}
                </CustomSection>
            ))}
       </>
    );
};

const imageColumns: Column[] = [
    {
        path: 'generalImage',
        label: 'GENERAL VIEW',
        headerStyle: { backgroundColor: '#00b0f0', color: '#FFFFFF' },
        content: (item) => (
            <div className="p-1">
                <Image
                    src={item.generalImage[0].src}
                    alt={item.generalImage[0].caption}
                />

                <Caption className="text-wrap">
                    <CaptionLabel>Photo #{item.generalImage[0].refNo}:</CaptionLabel> {item.generalImage[0].caption}
                </Caption>
            </div>
        )
    },
    {
        path: 'closeImage',
        label: 'CLOSE VIEW',
        headerStyle: { backgroundColor: '#00b0f0', color: '#FFFFFF' },
        content: (item: AnalysisItem) => (
            <div className="p-1">
                <Image
                    src={item.closeImage[0].src}
                    alt={item.closeImage[0].caption}
                />

                <Caption>
                    <CaptionLabel>Photo #{item.closeImage[0].refNo}:</CaptionLabel> {item.closeImage[0].caption}
                </Caption>
           </div>
        )
    },
];
 
export default CDRThreatAnalysisPDF;